import { useAppSelector } from '../../../../hooks';
import { selectWorkspaceMeasurementData } from '../../../../utils/measurementCalculation/measurementSource';
import { MeasurementPoints } from '../MeasurementPoints';
import { hasVisualizationValues } from '../measurementUtils';

/** Renders the computed measurement points for the drawn surfaces. The points are already
 *  draped onto the layer (z + 0.01, exactly like the whole-model "All model points"), so
 *  they're rendered at their raw positions — no extra group lift. The colour scale is taken
 *  from the whole-model measurement so surface points share the SAME scale/legend. */
export function MeasurementPlaneResults(): JSX.Element | null {
  const results = useAppSelector((s) => s.measurementPlanes.results);
  // Surface points show only when the switch is on "Surface points" (mutually exclusive
  // with the whole-model measurement points).
  const pointsView = useAppSelector((s) => s.measurementPlanes.pointsView);
  // The whole-model measurement data — used as the shared colour scale (All model points).
  const modelData = useAppSelector(selectWorkspaceMeasurementData) ?? undefined;
  const visualizationType = useAppSelector((s) => s.workspace.measurementVisualizationType);
  if (!results.length || pointsView !== 'surface') return null;
  // The model may not have the surface's quantity (an M-class road has luminance only, a P-norm
  // area illuminance): then the surface's own values give the scale, or its points stay grey.
  const scaleData = hasVisualizationValues(modelData, visualizationType) ? modelData : undefined;
  return <MeasurementPoints data={results} scaleData={scaleData} />;
}
